var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extra-container_clear"},[_c('button',{on:{"click":_vm.ClearCompleted}},[_vm._v("Clear Complete")])])}
var staticRenderFns = []

export { render, staticRenderFns }